export const FIELD_HELPERS = {
  ar: {
    additionalData: "معلومات إضافية مفصلة للإدخال في التحليل",
    quickExplanation: "شرح سريع أو ملاحظات مختصرة للتقرير (اختياري)",
    uploadExcel: "رفع ملف Excel لتحليل بيانات إضافية",
    uploadedData: "بيانات من ملف Excel مرفوع",
  },
  en: {
    additionalData: "Detailed additional information for analysis",
    quickExplanation: "Quick explanation or brief notes for the report (optional)",
    uploadExcel: "Upload Excel file for additional data analysis",
    uploadedData: "Data from uploaded Excel file",
  },
};

export const TOAST_MESSAGES = {
  ar: {
    reportGenerated: "تم إنشاء التقرير بنجاح",
    reportGeneratedWithIssues: "تم إنشاء التقرير مع بعض المشاكل",
    filtersApplied: "تم تطبيق الفلاتر",
    exporting: "جاري تصدير التقرير",
    exportSuccess: "تم التصدير بنجاح",
    resetSuccess: "تمت إعادة تعيين جميع الفلاتر",
    resetDesc: "تمت إعادة تعيين جميع الفلاتر إلى القيم الافتراضية",
    missingData: "بيانات ناقصة",
    exportError: "لا يمكن التصدير",
    reportError: "خطأ في إنشاء التقرير",
    loadError: "فشل في تحميل البيانات. يرجى المحاولة مرة أخرى.",
    apiSuccess: "تم الاتصال بالـ API بنجاح",
    apiError: "فشل الاتصال بالـ API",
    mockData: "تم استخدام بيانات تجريبية",
    aiAnalyzing: "جاري التحليل الذكي مع AI...",
    aiSuccess: "تم التحليل الذكي بنجاح",
    aiError: "خطأ في التحليل الذكي",
    uploadingFile: "جاري رفع الملف...",
    fileUploaded: "تم رفع الملف",
    parsedItems: "تم تحليل",
    rows: "صف",
    uploadExcelOnly: "يرجى رفع ملف Excel فقط (.xlsx, .xls, .csv)",
    invalidFile: "ملف غير صالح",
    uploadError: "خطأ في رفع الملف",
    readyForAnalysis: "جاهز للتحليل",
    preview: "معاينة البيانات",
    moreRows: "صف إضافي",
    excelWillBeAnalyzed: "سيتم تحليل بيانات Excel مع بيانات النظام في التحليل الذكي",
    excelRows: "صف من Excel",
    excelFile: "ملف Excel",
    columns: "عمود",
    withExcel: "مع Excel",
    excelUpload: "رفع ملفات Excel",
  },
  en: {
    reportGenerated: "Report generated successfully",
    reportGeneratedWithIssues: "Report generated with some issues",
    filtersApplied: "Filters applied",
    exporting: "Exporting report",
    exportSuccess: "Export successful",
    resetSuccess: "All filters reset",
    resetDesc: "All filters have been reset to default values",
    missingData: "Missing data",
    exportError: "Cannot export",
    reportError: "Error generating report",
    loadError: "Failed to load data. Please try again.",
    apiSuccess: "API connection successful",
    apiError: "API connection failed",
    mockData: "Using mock data",
    aiAnalyzing: "Analyzing with AI...",
    aiSuccess: "AI analysis completed",
    aiError: "AI analysis failed",
    uploadingFile: "Uploading file...",
    fileUploaded: "File uploaded",
    parsedItems: "Parsed",
    rows: "rows",
    uploadExcelOnly: "Please upload Excel files only (.xlsx, .xls, .csv)",
    invalidFile: "Invalid file",
    uploadError: "File upload error",
    readyForAnalysis: "Ready for analysis",
    preview: "Preview",
    moreRows: "more rows",
    excelWillBeAnalyzed: "Excel data will be analyzed with system data in smart analysis",
    excelRows: "rows from Excel",
    excelFile: "Excel file",
    columns: "columns",
    withExcel: "with Excel",
    excelUpload: "Excel upload",
  },
};
